if (!customElements.get('engraving-form')) {
  class EngravingForm extends HTMLElement {
    constructor() {
      super();
    }  

    connectedCallback() {
      // Get elements when DOM is ready
      this.toggleCheckbox = this.querySelector('#add-engraving');
      this.engravingOptions = this.querySelector('#engraving-options');
      this.fontRadios = this.querySelectorAll('input[name="engraving_font"]');
      this.textField = this.querySelector('#engraving-text');
      this.propertyInput = this.querySelector('#engraving-property-input');

       // Toggle show class and clear form data on checkbox change
       this.toggleCheckbox.addEventListener('change', () => {
         const checked = this.toggleCheckbox.checked;
         this.classList.toggle('show', checked);
         if (!checked) {
           this.fontRadios.forEach(radio => radio.checked = false);
           this.textField.value = '';
           this.updatePropertyValue();
         } else {
           // When checkbox is enabled, update property value to set name attribute
           this.updatePropertyValue();
         }
       });

       // Add input validation for engraving text
       this.textField.addEventListener('input', (e) => {
         const value = e.target.value;
         // Remove only emojis - iterate by code points to handle surrogate pairs correctly
         // Numbers 0-9 are U+0030-U+0039 (0x0030-0x0039), which are NOT in emoji ranges
         let cleanedValue = '';
         for (let i = 0; i < value.length; i++) {
           const codePoint = value.codePointAt(i);
           
           // Check if character is an emoji (common emoji Unicode ranges)
           // Numbers are in range 0x0030-0x0039, well below all emoji ranges
           const isEmoji = (
             (codePoint >= 0x1F300 && codePoint <= 0x1F9FF) || // Miscellaneous Symbols and Pictographs
             (codePoint >= 0x2600 && codePoint <= 0x26FF) ||   // Miscellaneous Symbols
             (codePoint >= 0x2700 && codePoint <= 0x27BF) ||   // Dingbats
             (codePoint >= 0x1F900 && codePoint <= 0x1F9FF) || // Supplemental Symbols and Pictographs
             (codePoint >= 0x1F1E0 && codePoint <= 0x1F1FF) || // Regional Indicator Symbols
             (codePoint >= 0x1F600 && codePoint <= 0x1F64F) || // Emoticons
             (codePoint >= 0x1F680 && codePoint <= 0x1F6FF) || // Transport and Map Symbols
             (codePoint >= 0x1F700 && codePoint <= 0x1F77F) || // Alchemical Symbols
             (codePoint >= 0x1F780 && codePoint <= 0x1F7FF) || // Geometric Shapes Extended
             (codePoint >= 0x1F800 && codePoint <= 0x1F8FF) || // Supplemental Arrows-C
             (codePoint >= 0x1FA00 && codePoint <= 0x1FAFF) || // Chess Symbols
             codePoint === 0x200D || // Zero Width Joiner
             codePoint === 0xFE0F    // Variation Selector-16
           );
           
           if (!isEmoji) {
             // Add character - handle surrogate pairs correctly
             cleanedValue += String.fromCodePoint(codePoint);
             // Skip next index if this was a surrogate pair
             if (codePoint > 0xFFFF) {
               i++;
             }
           } else if (codePoint > 0xFFFF) {
             // Skip next index for surrogate pair emojis
             i++;
           }
         }
         
         if (value !== cleanedValue) {
           e.target.value = cleanedValue;
         }
         
         // Update property value when text changes
         this.updatePropertyValue();
       });

       // Update property value when font selection changes
       this.fontRadios.forEach(radio => {
         radio.addEventListener('change', () => {
           this.updatePropertyValue();
         });
       });
    }

    updatePropertyValue() {
      if (!this.propertyInput) return;
      
      const selectedFont = this.getSelectedFont();
      const engravingText = this.textField.value.trim();
      
      if (this.toggleCheckbox.checked && selectedFont && engravingText) {
        const propertyValue = `Text - ${engravingText} / Font - ${selectedFont}`;
        this.propertyInput.value = propertyValue;
        
        // Manually sync to the hidden input in the product form
        this.syncToProductForm(propertyValue);
        this.syncToPreviewBox(engravingText);
      } else {
        this.propertyInput.value = '';
        this.syncToProductForm('');
        this.syncToPreviewBox();
      }
    }

    syncToProductForm(value) {
      // Find the hidden input in the product form
      const productForm = document.querySelector('[data-product-form]');
      if (productForm) {
        const hiddenInput = productForm.querySelector('[data-engraving-input]');
        if (hiddenInput) {
          // Update value
          hiddenInput.value = value;
          
          // Update name attribute only if all conditions are met:
          // 1. Checkbox is enabled
          // 2. Font radio is selected
          // 3. Engraving text is not empty
          const selectedFont = this.getSelectedFont();
          const engravingText = this.textField.value.trim();
          
          if (this.toggleCheckbox.checked && selectedFont && engravingText && value) {
            hiddenInput.setAttribute('name', 'properties[engraving]');
          } else {
            hiddenInput.removeAttribute('name');
          }
          
          // Trigger change event to ensure theme's sync mechanism works
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    syncToPreviewBox(engravingText = '') {
      const previewBox = this.querySelector('[data-engraving-preview]');

      if (!previewBox) {
        return;
      }

      previewBox.textContent = engravingText;

      if (engravingText) {
        const selectedRadio = Array.from(this.fontRadios).find(radio => radio.checked);

        previewBox.classList.forEach(className => {
          previewBox.classList.toggle(className, !className.startsWith('engraving-font-'));
        });

        previewBox.classList.add(selectedRadio.dataset.fontClass);
      }
    }

    getSelectedFont() {
      const selectedRadio = Array.from(this.fontRadios).find(radio => radio.checked);
      return selectedRadio ? selectedRadio.value : '';
    }
  }

  customElements.define('engraving-form', EngravingForm);
}